import React, { createContext, useContext, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getUserByIdAsync } from '../../../../features/users/usersActions';
import { selectCanManageUsers } from '../../../../features/users/usersSlice';
const UserDetailContext = createContext(null);
export function UserDetailProvider({ children }) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const profile = useSelector(state => state.users.profiles[id]);
  const canManage = useSelector(selectCanManageUsers);
  const reload = useCallback(() => dispatch(getUserByIdAsync(id)), [dispatch, id]);
  useEffect(() => { const request = reload(); return () => request.abort(); }, [reload]);
  return <UserDetailContext.Provider value={{ id, user: profile?.data, canManage, reload,
    loading: !profile?.requestId || profile.loading, error: profile?.error }}>{children}</UserDetailContext.Provider>;
}
export function useUserDetail() {
  const context = useContext(UserDetailContext);
  if (!context) throw new Error('useUserDetail requires UserDetailProvider.');
  return context;
}
